export { default as Img200 } from './processed/200/Archer_S10.jpg';
export { default as Img400 } from './processed/400/Archer_S10.jpg';
export { default as Imgthumb } from './processed/thumb/Archer_S10.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Archer_S10.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Archer_S10.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      198,
      111,
      51
    ],
    "_population": 988,
    "_hsl": [
      0.06802721088435375,
      0.5903614457831324,
      0.4882352941176471
    ]
  },
  "LightVibrant": {
    "_rgb": [
      235,
      203,
      169
    ],
    "_population": 502,
    "_hsl": [
      0.08585858585858586,
      0.6226415094339619,
      0.792156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      28,
      60
    ],
    "_population": 3,
    "_hsl": [
      0.5952380952380952,
      0.875,
      0.12549019607843137
    ]
  },
  "Muted": {
    "_rgb": [
      126,
      121,
      126
    ],
    "_population": 1910,
    "_hsl": [
      0.8333333333333334,
      0.020242914979757127,
      0.4843137254901961
    ]
  },
  "LightMuted": {
    "_rgb": [
      190,
      180,
      177
    ],
    "_population": 1858,
    "_hsl": [
      0.03846153846153866,
      0.09090909090909098,
      0.7196078431372549
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      54,
      53
    ],
    "_population": 1956,
    "_hsl": [
      0.005208333333333316,
      0.23188405797101444,
      0.27058823529411763
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Archer_S10.js